import type { Locale } from "@project/i18n";
import { localeToIntlTag } from "@project/i18n";

/** Formatea importe en menor unidad (p. ej. céntimos) con ISO 4217. */
export function formatMinorAsCurrency(
  amountMinor: number,
  currency: string,
  locale: Locale,
): string {
  const intlLocale = localeToIntlTag(locale);
  const major = amountMinor / 100;
  return new Intl.NumberFormat(intlLocale, {
    style: "currency",
    currency: currency.length === 3 ? currency : "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(major);
}
